import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, cn } from '@parcel/ui';

export interface MenuOption {
  value: string;
  label: string;
}

/** One word picked from a short list (an operator, a unit), on shadcn's Select. */
export function MenuSelect({
  label,
  value,
  options,
  onChange,
  disabled,
  className,
}: {
  label: string;
  value: string;
  options: readonly MenuOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger size="sm" aria-label={label} className={cn('shrink-0 px-2.5', className)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
